import { Box, Flex, Heading, Text } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/react";
import { useState } from "react";

import "./navigation.css";
import { useLocation } from "react-router-dom";
import { getComponentTitle } from "./components/GetComponentTitle";
import { AiOutlineAlignLeft } from "react-icons/ai";
import dayjs from "dayjs";
import {
  ESTATE_OPTIONS,
  SELECTED_ESTATE_STORAGE_KEY,
} from "../../services/api";

export const Navigation = ({ toggle, showSidBar, userType, type }) => {
  const [toggleSide] = useState(false);
  const [selectedEstate, setSelectedEstate] = useState(
    () =>
      localStorage.getItem(SELECTED_ESTATE_STORAGE_KEY) ||
      ESTATE_OPTIONS.AAHERA
  );
  const location = useLocation();
  const pathname = location.pathname;

  const handleToggle = () => {
    toggle(!toggleSide);
  };

  const handleEstateChange = (event) => {
    const estate = event.target.value;

    setSelectedEstate(estate);
    localStorage.setItem(SELECTED_ESTATE_STORAGE_KEY, estate);
    window.location.reload();
  };

  return (
    <Box position="relative">
      <Box className="navigation-inner">
        <Flex
          width="100%"
          padding="20px 10px"
          alignItems="center"
          gap="16px"
          flexWrap="wrap"
        >
          <Flex alignItems="center" minWidth="0" flex="1">
            <Box className="toggle-side-bar">
              {showSidBar ? (
                <AiOutlineAlignLeft
                  onClick={handleToggle}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                ""
              )}
            </Box>

            {/* <Flex
              alignItems={"center"}
              justifyContent={"space-between"}
              w="100%"
            > */}
            <Heading color="#000" size="md" marginLeft={["5px", "30px"]}>
              {getComponentTitle(pathname)}
            </Heading>
          </Flex>

          <Box
            display={"flex"}
            alignItems="center"
            gap="20px"
            className="date"
            fontSize={[".8em", ".9em", "1em"]}
            flexWrap={["wrap", "nowrap"]}
            justifyContent="flex-end"
            ml="auto"
          >
            <Select
              aria-label="Select estate"
              value={selectedEstate}
              onChange={handleEstateChange}
              bg="#fff"
              borderColor="#E2E8F0"
              color="#000"
              fontWeight="600"
              maxWidth={["100%", "260px"]}
              minWidth={["100%", "220px"]}
              size="sm"
            >
              <option value={ESTATE_OPTIONS.AAHERA}>
                Aahera (The Main Estate)
              </option>
              <option value={ESTATE_OPTIONS.JUBILEE}>Jubilee</option>
              <option value={ESTATE_OPTIONS.URBAN_SHELTER}>
                Urban Shelter
              </option>
            </Select>

            <Flex alignItems="center" whiteSpace="nowrap">
              <Text color="#000"> {dayjs().format("ddd, MMM D, YYYY")} </Text>
              <Text ml="20px" color="#000">
                {" "}
                {dayjs().format("HH:mm")}{" "}
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
